import { getPinnedAwareVisibleLeafColumns } from '../../../domain/table/tableHeadUseCase';

/**
 * Colgroup that locks leaf column widths on a group body table (table-layout: fixed).
 * @param {object} props
 * @param {TableInstance} props.table
 * @returns {JSX.Element}
 */
function TableColGroup({ table }) {
  const leafColumns = getPinnedAwareVisibleLeafColumns(table);

  return (
    <colgroup>
      {leafColumns.map((column) => (
        <col
          key={column.id}
          style={{ width: `${column.getSize()}px` }}
        />
      ))}
    </colgroup>
  );
}

export default TableColGroup;
